
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import { IDrag } from "./interface";

@Component({
  name: "ui-drag",
  components: {
    draggable,
  },
})
export default class UiDragComponent extends Vue {
  @Prop() value: Array<IDrag>;

  isDrag: boolean = false;
  innerValue: Array<IDrag>;

  created() {
    if (this.value) this.innerValue = this.value;
  }

  onInnerValueChanged(items: Array<IDrag>) {
    items.forEach((item, index) => {
      item.SortIndex = index + 1;
    });
    this.$forceUpdate();
    this.$emit("input", items);
  }

  mounted() {}
}
